import React from 'react';
import styles from './style.module.scss';

type TContainerProps = {
  children: React.ReactNode;
};

const Container: React.FC<TContainerProps> = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};

export default Container;
